import { cn } from "@/lib/utils";
import { createRef, type RefObject } from "react";

export function Row({
  ref,
  id,
  noGap,
  onClick,
  children,
  className,
  onKeyDown,
  end = false,
  align = false,
  start = false,
  bigGap = false,
  shrink = false,
  between = false,
  tightGap = false,
  fullHeight = false,
  justifyEnd = false,
}: {
  ref?: RefObject<HTMLDivElement | null>;
  id?: string;
  end?: boolean;
  noGap?: boolean;
  align?: boolean;
  start?: boolean;
  bigGap?: boolean;
  shrink?: boolean;
  between?: boolean;
  className?: string;
  tightGap?: boolean;
  fullHeight?: boolean;
  justifyEnd?: boolean;
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
}) {
  return (
    <div
      id={id}
      ref={ref}
      onClick={onClick}
      onKeyDown={onKeyDown}
      className={cn(
        "flex flex-row gap-4 w-full flex-1",
        shrink && "flex-initial w-fit",
        noGap && "gap-0",
        tightGap && "gap-2",
        bigGap && "gap-8",
        align && "items-center",
        between && "justify-between",
        fullHeight && "h-full",
        end && "items-end",
        justifyEnd && "justify-end",
        start && "items-start",
        className,
      )}
    >
      {children}
    </div>
  );
}
Row.displayName = "Row";
